import styled from 'styled-components';

// Note: Le logo est au format 171:64 mais le header actuel ne fait que 48px
// Pour compenser, on force l'affichage en 171:48 et on crop verticalement
// Il faudra corriger ce ratio lors du changement de taille du header
export const Img = styled.img`
  aspect-ratio: 171 / 48;
  object-fit: cover;
  width: 171px;
`;
